import { render } from "./HermesBreadcrumbs.vue?vue&type=template&id=25b9a37a&scoped=true"
import script from "./HermesBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./HermesBreadcrumbs.vue?vue&type=script&lang=js"

import "./HermesBreadcrumbs.vue?vue&type=style&index=0&id=25b9a37a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b9a37a"]])

export default __exports__